import script from "./FilterMemberships.vue?vue&type=script&lang=ts&setup=true"
export * from "./FilterMemberships.vue?vue&type=script&lang=ts&setup=true"

export default script